<template>
  <div class="park-detail-info-ad" v-if="popularPushDatas.length">
    <div class="park-detail-info-sub-title">产业聚集区地块</div>
    <div class="park-detail-info-sub">
      <div
        v-for="(item,index) in popularPushDatas"
        :key="index"
        class="park-detail-info-ad-item"
      >
        <img
          :src="item.imgUrl? item.imgUrl: require('@/assets/images/home/land.png')"
          class="ad-img-t"
        />
        <div class="park-detail-info-ad-item-r">
          <div class="ad-name">{{item.name}}</div>
          <div class="ad-price">{{item.typeName}}</div>
          <div class="ad-span">
            <div>{{item.countyName}}</div>
            <div>{{item.area}}公顷</div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getParkPage, getParkLandList } from "@/api/setting/investment";
/**
 * @Author LuoYang
 * @Email toluoyang@qq.com
 * @Date 2022/7/18 15:29
 * @Description 园区关联地块列表
 */
export default {
  name: "ParkPopularPush",
  props: {
    parkCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      popularPushDatas: [
        {
          countyName: "昆明市",
          name: "地块三十六",
          typeName: "批发零售用地",
          area: 0.14,
        },
        {
          countyName: "曲靖市",
          name: "地块三十七",
          typeName: "批发零售用地",
          area: 0.14,
        },
        {
          countyName: "丽江市",
          name: "地块三十八",
          typeName: "批发零售用地",
          area: 0.14,
        },
      ],
    };
  },
  watch: {
    parkCode: function (newVal) {
      this.getList();
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      getParkLandList(this.parkCode).then((res) => {
        if (res.data.success) {
          this.popularPushDatas = res.data.data.length
            ? res.data.data
            : this.popularPushDatas;
        }
      });
    },
  },
};
</script>

<style scoped>
.park-detail-info-ad {
  height: 265px;
  width: 100%;
}

.park-detail-info-sub-title {
  width: 200px;
  color: #495eb8;
  font-weight: 600;
  font-size: 0.85rem;
  background: linear-gradient(90deg, #9fccff, #1f42a100);
  padding: 5px 10px;
}
.park-detail-info-sub {
  display: flex;
  width: 100%;
  height: calc(100% - 29px);
  overflow: auto;
  flex-grow: 1;
}
.park-detail-info-ad-item {
  border: 1px solid #d9d9d9;
  padding: 4px;
  margin: 8px 1.2% 8px 0;
  display: flex;
  flex-direction: column;
  width: 23%;
  flex: 0 0 auto;
}

.ad-img-t {
  width: 100%;
  height: 125px;
}
.park-detail-info-ad-item-r {
  width: 100%;
  height: calc(100% - 125px);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.ad-name {
  font-size: 0.8rem;
  color: #303030;
}

.ad-price {
  color: #1446a6;
  font-size: 0.85rem;
  font-weight: bold;
}

.ad-info-box {
  display: flex;
  font-size: 0.75rem;
  color: #5c5c5c;
}
.ad-span {
  display: flex;
  font-size: 0.75rem;
  color: #828181;
}
.ad-span > div:first-child {
  padding-right: 10px;
  border-right: 1px solid #a9a8a8;
}
.ad-span > div:last-child {
  padding-left: 10px;
}
</style>
